import { apiRequest } from "../http";
import { IResponse } from "../../types/response.type";
import type {
	CreateSessionSuccessData,
	ListSessionsSuccessData,
	GetSessionSuccessData,
	UpdateSessionTitleSuccessData,
	DeleteSessionSuccessData,
	ArchiveSessionSuccessData,
} from "../../types/session.type";

export type ICreateSessionResponse = IResponse<CreateSessionSuccessData>;
export type IListSessionsResponse = IResponse<ListSessionsSuccessData>;
export type IGetSessionResponse = IResponse<GetSessionSuccessData>;
export type IUpdateSessionTitleResponse =
	IResponse<UpdateSessionTitleSuccessData>;
export type IDeleteSessionResponse = IResponse<DeleteSessionSuccessData>;
export type IArchiveSessionResponse = IResponse<ArchiveSessionSuccessData>;

export async function createSession(body: {
	user_id: string;
	title?: string | null;
}): Promise<ICreateSessionResponse> {
	return await apiRequest<CreateSessionSuccessData>({
		path: "/api/sessions",
		method: "POST",
		json: body,
	});
}

export async function listSessions(params: {
	user_id: string;
	include_deleted?: boolean;
	limit?: number;
	cursor?: string | null;
}): Promise<IListSessionsResponse> {
	// Формируем URL строку с параметрами
	const qp = new URLSearchParams();
	if (params.user_id != null) qp.set("user_id", String(params.user_id));
	if (params.include_deleted != null)
		qp.set("include_deleted", String(params.include_deleted));
	if (params.limit != null) qp.set("limit", String(params.limit));
	if (params.cursor != null) qp.set("cursor", String(params.cursor));

	const path = qp.toString()
		? `/api/sessions?${qp.toString()}`
		: "/api/sessions";

	return await apiRequest<ListSessionsSuccessData>({
		path,
		method: "GET",
	});
}

export async function getSession(params: {
	session_id: string;
	user_id: string;
}): Promise<IGetSessionResponse> {
	return await apiRequest<GetSessionSuccessData>({
		path: `/api/sessions/${encodeURIComponent(params.session_id)}`,
		method: "GET",
		query: { user_id: params.user_id },
	});
}

export async function updateSessionTitle(params: {
	session_id: string;
	user_id: string;
	body: { title: string };
}): Promise<IUpdateSessionTitleResponse> {
	return await apiRequest<UpdateSessionTitleSuccessData>({
		path: `/api/sessions/${encodeURIComponent(params.session_id)}?user_id=${params.user_id}`,
		method: "PATCH",
		json: params.body,
	});
}

export async function deleteSession(params: {
	session_id: string;
	user_id: string;
}): Promise<IDeleteSessionResponse> {
	return await apiRequest<DeleteSessionSuccessData>({
		path: `/api/sessions/${encodeURIComponent(params.session_id)}?user_id=${params.user_id}`,
		method: "DELETE",
	});
}

export async function archiveSession(
	session_id: string,
): Promise<IArchiveSessionResponse> {
	return await apiRequest<ArchiveSessionSuccessData>({
		path: `/api/sessions/${encodeURIComponent(session_id)}/archive`,
		method: "POST",
	});
}
